import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import _sortBy from 'lodash/sortBy';
import TextField from '../../../common/TextField';
import Select from '../../../common/Select';
import _get from 'lodash/get';
import { getTextFromLanguage } from '../../../../helper/languageHelper';
const uuidv4 = require('uuid/v4');

const ProductAttributeDescription = ({
  classes,
  productAttribute,
  productAttributeId,
  updateProductAttribute,
  languages
}) => {
  const descriptionId =
    productAttribute.description && productAttribute.description.id
      ? productAttribute.description.id
      : uuidv4();
  return (
    <Grid container>
      {languages.map((language, index) => {
        var descriptionText = '';
        try {
          descriptionText = getTextFromLanguage(
            productAttribute.description.text,
            language
          );
        } catch (error) {}
        return (
          <Grid
            container
            key={'style-descriptionText-' + index}
            direction="row"
            alignItems="flex-start"
            spacing={1}
            className={classes.container}
          >
            <Grid item xs={10}>
              <TextField
                dataCy={'Attribute-Description-' + language}
                label="Description"
                placeholder="Enter description"
                multiline={true}
                rowsMax="4"
                value={descriptionText}
                onChange={e => {
                  updateProductAttribute({
                    optimisticResponse: {
                      __typename: 'Mutation',
                      updateProductAttribute: {
                        ...productAttribute,
                        description: {
                          id: descriptionId,
                          text: [
                            ...languages.map((tempLanguage, index) => {
                              return {
                                langCode: tempLanguage,
                                content:
                                  tempLanguage === language
                                    ? e.target.value
                                    : getTextFromLanguage(
                                        productAttribute.description.text,
                                        tempLanguage
                                      ),
                                __typename: 'TextContent'
                              };
                            })
                          ],
                          __typename: 'Text'
                        }
                      }
                    },
                    variables: {
                      id: productAttributeId,
                      input: {
                        description: {
                          id: descriptionId,
                          text: [
                            ...languages.map((tempLanguage, index) => {
                              return {
                                langCode: tempLanguage,
                                content:
                                  tempLanguage === language
                                    ? e.target.value
                                    : getTextFromLanguage(
                                        productAttribute.description.text,
                                        tempLanguage
                                      )
                              };
                            })
                          ]
                        }
                      }
                    }
                  });
                }}
              />
            </Grid>
            <Grid item xs={2}>
              <Grid
                container
                alignItems="center"
                justify="center"
                style={{
                  height: 38,
                  width: '100%',
                  border: '1px solid #ddd',
                  borderRadius: '3px',
                  marginTop: 24
                }}
              >
                {language}
              </Grid>
            </Grid>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default ProductAttributeDescription;
